/**
 * Form widget states
 * Defined in WidgetState.kt
 */

export default {
	EDITABLE: 'editable',
	CLICKABLE: 'clickable',
	TEXT_ONLY: 'text-only',
	DISABLED: 'disabled',
	VISIBLE: 'visible',
	HIDDEN: 'hidden'
}